export enum AppRecordStatusJK {
  loading,
  loadingMore,
  noLoadMore,
  loaded,
}

export class AppRecordJK {
  public loadingStatus: AppRecordStatusJK;
  public currentPage: number;
  public currentIndex: number;
  public nextPageUrl?: string | null;
  public totalRecord: number;
  public records: any[];

  constructor({
    loadingStatus = AppRecordStatusJK.loading,
    currentPage = 1,
    currentIndex = 0,
    nextPageUrl = null,
    totalRecord = 0,
    records = [],
  }: Partial<{
    loadingStatus: AppRecordStatusJK;
    currentPage: number;
    currentIndex: number;
    nextPageUrl?: string | null;
    totalRecord: number;
    records: any[];
  }> = {}) {
    this.loadingStatus = loadingStatus;
    this.currentPage = currentPage;
    this.currentIndex = currentIndex;
    this.nextPageUrl = nextPageUrl;
    this.totalRecord = totalRecord;
    this.records = records;
  }

  public canLoadMore(): boolean {
    return this.loadingStatus !== AppRecordStatusJK.loading && this.loadingStatus !== AppRecordStatusJK.loadingMore && this.loadingStatus !== AppRecordStatusJK.noLoadMore;
  }

  public isLoading(): boolean {
    return this.loadingStatus === AppRecordStatusJK.loading;
  }

  public isLoadingMore(): boolean {
    return this.loadingStatus === AppRecordStatusJK.loadingMore;
  }

  public isNoLoadMore(): boolean {
    return this.loadingStatus === AppRecordStatusJK.noLoadMore;
  }
}

